export default class AccordionGroup extends HTMLElement {
  constructor() {
    super();
    this.onAccordionOpen = this.onAccordionOpen.bind(this);
  }

  connectedCallback() {
    this.addEventListener('accordion:open', this.onAccordionOpen);
  }

  disconnectedCallback() {
    this.removeEventListener('accordion:open', this.onAccordionOpen);
  }

  onAccordionOpen(e) {
    const openedAccordion = e.detail.accordion;

    this.querySelectorAll('c-accordion').forEach(accordion => {
      if (accordion !== openedAccordion && accordion.$container?.open) {
        accordion.shrink();
      }
    });
  }
}
